import React, { useCallback, useEffect, useState } from 'react'
import { GridSearchIcon } from '@mui/x-data-grid'
import { getBookingStatus } from '../../../services/event'
import '../style.scss'
import {
	Button,
	FormControl,
	InputAdornment,
	InputLabel,
	MenuItem,
	Select,
	TextField,
	Tooltip,
	debounce,
	Card,
	CardContent,
	Grid,
	Box,
	Typography,
	Paper,
	Chip,
	IconButton,
	Divider,
} from '@mui/material'
import {
	capitalizeWords,
	exportFromJSON,
	getAreas,
	isMobileScreen,
} from '../../../utils'
import { ACCOMODATION_CATEGORY, EVENT_BOOKING_STATUS } from '../../../constants'
import {
	CloudDownload,
	FilterList,
	Refresh,
	Clear
} from '@mui/icons-material'
import { format } from 'date-fns'
import { useDispatch } from 'react-redux'
import { HIDE_MAIN_LOADER, SHOW_MAIN_LOADER } from '../../../constants/actions'
import { getEventById } from '../../../data/event'
import { CustomDataGrid } from '../../../components/CustomTable/CustomDataGrid'
import { EXTRA_FIELDS_MAP } from '../../Notification/constants'

const getKeysInSameOrder = (obj) => {
	let out = []
	let keys = Object.keys(obj)
	let localKeys = [0, 1, 2, 3, 4, 5, 6, 8, 9, 10, 7, 11, 12, 13]
	for (let key of localKeys) {
		if (keys.includes(String(key))) {
			out.push(key)
		}
	}
	return out
}

const ReportScreen = ({ eventId }) => {
	const [filters, setFilters] = useState({
		status: ['ALL'],
		areaId: ['ALL'],
		accomodation: ['ALL'],
		transportation: ['ALL'],
		pageSize: 10,
		page: 0,
	})
	const [searchValue, setSearchValue] = useState('')
	const [data, setData] = useState([])
	const [loading, setLoading] = useState(false)
	const [rowCount, setRowCount] = useState(0)
	const dispatch = useDispatch()

	useEffect(() => {
		updateBookingData()
	}, [])

	useEffect(() => {
		updateBookingData(searchValue)
	}, [filters, searchValue])

	const updateBookingData = useCallback(
		(q) => {
			const status =
				filters.status[0] === 'ALL'
					? Object.keys(EVENT_BOOKING_STATUS)
						.filter((el) => String(el) !== '1')
						.join(',')
					: filters.status.join(',')
			const areaId =
				filters.areaId[0] === 'ALL'
					? undefined
					: filters.areaId.join(',')
			const accomodation =
				filters.accomodation[0] === 'ALL'
					? undefined
					: filters.accomodation.join(',')
			const transportation =
				filters.transportation[0] === 'ALL'
					? undefined
					: filters.transportation.join(',')
			setLoading(true)
			getBookingStatus({
				...filters,
				page: filters.page + 1,
				per_page: filters.pageSize,
				status,
				areaId,
				accomodation,
				transportation,
				eventId,
				q,
			})
				.then((res) => {
					const filteredData = res.data.data.filter((el) => el.status !== 1)
					setData(filteredData)
					setRowCount(res.data.total_results)
					setLoading(false)
				})
				.catch((e) => {
					setLoading(false)
				})
		},
		[filters]
	)


	const onPageSizeChange = ({ page, pageSize }) => {
		setFilters((f) => ({
			...f,
			page,
			pageSize,
		}))
	}

	const clearFilters = () => {
		setFilters({
			status: ['ALL'],
			areaId: ['ALL'],
			accomodation: ['ALL'],
			transportation: ['ALL'],
			pageSize: 10,
			page: 0,
		})
		setSearchValue('')
	}

	const rowWidthConfig = {
		name: { default: { flex: 0.15 }, mobile: { width: 150 } },
		phone: { default: { flex: 0.1 }, mobile: { width: 150 } },
		email: { default: { flex: 0.2 }, mobile: { width: 200 } },
		facilitator: { default: { flex: 0.15 }, mobile: { width: 150 } },
		area: { default: { flex: 0.2 }, mobile: { width: 150 } },
		status: { default: { flex: 0.2 } },
		accomodation: { default: { flex: 0.15 }, mobile: { width: 150 } },
		transportation: { default: { flex: 0.15 }, mobile: { width: 100 } },
		cf1_value: { default: { flex: 0.15 }, mobile: { width: 100 } },
		// user: { default: { width: 160 } },
	}

	const headCells = [
		{
			field: 'name',
			numeric: false,
			headerName: 'Name',
			sortable: false,
		},
		{
			field: 'phone',
			numeric: false,
			headerName: 'Phone',
			sortable: false,
		},
		{
			field: 'email',
			numeric: false,
			headerName: 'Email',
			sortable: false,
		},
		{
			field: 'area',
			numeric: false,
			headerName: 'Area',
			sortable: false,
		},
		{
			field: 'facilitator',
			numeric: false,
			headerName: 'Facilitator',
			sortable: false,
		},

		{
			field: 'status',
			numeric: false,
			headerName: 'Status',
			sortable: false,
			renderCell: (params) => {
				return (
					<Tooltip
						title={params?.row?.subsidyReason}
						placement="top"
						arrow
					>
						<p
							className={
								params?.row?.subsidyReason ? 'subsidy' : ''
							}
						>
							{params.value}
						</p>
					</Tooltip>
				)
			},
		},
		{
			field: 'accomodation',
			numeric: false,
			headerName: 'Accomodation',
			sortable: true,
		},
		{
			field: 'transportation',
			numeric: false,
			headerName: 'Transportation',
			sortable: false,
		},
		{
			field: 'cf1_value',
			numeric: false,
			headerName: 'Extra Input',
			sortable: false,
			renderCell: (params) => {
				return <p className={'text-black'}>{params.value}</p>
			},
		},
		// {
		// 	field: 'user',
		// 	headerName: 'Actions',
		// 	sortable: false,
		// 	filterable: false,
		// 	renderCell: (params) => (
		// 		<strong>
		// 			<IconButton
		// 				onClick={() => viewRequest(params.value)}
		// 				aria-label="View Details"
		// 				color="primary"
		// 				title="View Details"
		// 			>
		// 				<Visibility />
		// 			</IconButton>
		// 			<IconButton
		// 				onClick={() => approveRequest(params.value)}
		// 				aria-label="Activate"
		// 				color="primary"
		// 				title="Activate"
		// 			>
		// 				<CheckCircleRounded />
		// 			</IconButton>
		// 		</strong>
		// 	),
		// },
	]

	const onFilterChange = (name, value) => {
		let whatAdded, whatRemoved
		if (value.length > filters[name].length) {
			whatAdded = value.find((f) => !filters[name].includes(f))
		} else {
			whatRemoved = filters[name].find((f) => !value.includes(f))
		}
		if (typeof whatAdded !== undefined) {
			if (whatAdded === 'ALL') value = ['ALL']
			else value = value.filter((e) => e !== 'ALL')
		} else if (typeof whatRemoved !== undefined) {
			if (whatRemoved === 'ALL') value = value.length ? value : ['ALL']
		}
		setFilters((f) => ({
			...f,
			[name]: value,
			page: 1,
		}))
	}

	const download = () => {
		const todayDate = format(new Date(), 'dd-MM-yyyy')
		const fileName =
			capitalizeWords(
				getEventById(eventId)
					?.id?.toUpperCase()
					.replaceAll('-', ' ')
					.replaceAll('--', ' ')
			) +
			' Bookings ' +
			todayDate
		const status =
			filters.status[0] === 'ALL'
				? Object.keys(EVENT_BOOKING_STATUS)
					.filter((el) => String(el) !== '1')
					.join(',')
				: filters.status.join(',')
		const areaId =
			filters.areaId[0] === 'ALL' ? undefined : filters.areaId.join(',')
		const accomodation =
			filters.accomodation[0] === 'ALL'
				? undefined
				: filters.accomodation.join(',')
		const transportation =
			filters.transportation[0] === 'ALL'
				? undefined
				: filters.transportation.join(',')
		dispatch({ type: SHOW_MAIN_LOADER })
		getBookingStatus({
			...filters,
			status,
			areaId,
			accomodation,
			transportation,
			page: 1,
			per_page: 5000,
			eventId,
		})
			.then((res) => {
				exportFromJSON({
					data: res.data?.data?.map((s) => ({
						name: s.userId?.initiatedName || s.userId?.name,
						email: s.userId?.email,
						phone: s.userId?.phone,
						area: s.connectedAreaId?.name,
						status: EVENT_BOOKING_STATUS[s.status],
						facilitator:
							s.userId?.facilitator?.initiatedName ||
							s.userId?.facilitator?.name,
						chantingRounds: s?.userId?.chantingRounds,
						accomodation:
							ACCOMODATION_CATEGORY[s.accomodationCategory]?.name,
						transportation: s.transportationAmount ? 'Yes' : 'No',
						bookingDateTime: s.bookingDateTime,
						comments: s.comments,
						'Total Amount': s.finalAmount,
						'Paid Amount': s.paidAmount,
						'Subsidy (Discount)': s.subsidy,
						hotelName: s.inventoryId?.hotelName,
						paymentMethod: s.method,
						outfitCount: s.outfitCount,
						referrer: s.referrer,
						[EXTRA_FIELDS_MAP[s.cf1]]: s.cf1_value,
						[EXTRA_FIELDS_MAP[s.cf2]]: s.cf2_value,
					})),
					fileName,
				})
				dispatch({ type: HIDE_MAIN_LOADER })
			})
			.catch((e) => {
				dispatch({ type: HIDE_MAIN_LOADER })
			})
	}

	// const filteredData = data.filter((b) => {
	// 	return (
	// 		((filters.status.length <= 1 && filters.status[0] === 'ALL') ||
	// 			filters.status.includes(b.status)) &&
	// 		((filters.areaId.length <= 1 && filters.areaId[0] === 'ALL') ||
	// 			filters.areaId.includes(b.connectedAreaId._id)) &&
	// 		((filters.transportation.length <= 1 &&
	// 			filters.transportation[0] === 'ALL') ||
	// 			filters.transportation.includes(!!b.transportationAmount)) &&
	// 		((filters.accomodation.length <= 1 &&
	// 			filters.accomodation[0] === 'ALL') ||
	// 			filters.accomodation.includes(b.accomodationCategory))
	// 	)
	// })

	const transformData = (data = []) => {
		return (
			data.map((s) => ({
				...s,
				id: s._id,
				name: s.userId.initiatedName || s.userId.name,
				email: s.userId.email,
				phone: s.userId.phone,
				area: s.connectedAreaId.name,
				status: EVENT_BOOKING_STATUS[s.status],
				facilitator:
					s.userId.facilitator?.initiatedName ||
					s.userId.facilitator?.name,
				accomodation:
					ACCOMODATION_CATEGORY[s.accomodationCategory]?.name,
				transportation: s.transportationAmount ? 'Yes' : 'No',
				cf1_value: s.cf1_value,
			})) || []
		)
	}

	return (
		<div className="screen report-screen">

			{/* Filters Section */}
			<Card sx={{ mb: 3 }}>
				<CardContent>
					<Box display="flex" alignItems="center" mb={2}>
						<FilterList sx={{ mr: 1, color: 'primary.main' }} />
						<Typography variant="h6" color="primary">
							Filters & Search
						</Typography>
						<Box flexGrow={1} />
						<Box display="flex" gap={1}>
							<Button
								variant="outlined"
								startIcon={<Refresh />}
								onClick={() => updateBookingData(searchValue)}
								size="small"
							>
								Refresh
							</Button>
							<Button
								variant="contained"
								startIcon={<CloudDownload />}
								onClick={download}
								size="small"
							>
								Export
							</Button>
							<Button
								variant="outlined"
								startIcon={<Clear />}
								onClick={clearFilters}
								size="small"
							>
								Clear All
							</Button>
						</Box>
					</Box>

					<Grid container spacing={2}>
						<Grid item xs={12} sm={6} md={3}>
							<TextField
								fullWidth
								label="Search"
								InputProps={{
									startAdornment: (
										<InputAdornment position="start">
											<GridSearchIcon />
										</InputAdornment>
									),
								}}
								onChange={(e) => setSearchValue(e.target.value)}
								value={searchValue}
								placeholder="Search by name, email, phone..."
							/>
						</Grid>
						<Grid item xs={12} sm={6} md={3}>
							<FormControl fullWidth variant="outlined">
								<InputLabel>Area</InputLabel>
								<Select
									multiple
									value={filters.areaId}
									onChange={(e) => onFilterChange(e.target.name, e.target.value)}
									label="Area"
									name="areaId"
								>
									<MenuItem value={'ALL'}>All Areas</MenuItem>
									{getAreas().map((area) => (
										<MenuItem key={area._id} value={area._id}>{area.name}</MenuItem>
									))}
								</Select>
							</FormControl>
						</Grid>
						<Grid item xs={12} sm={6} md={3}>
							<FormControl fullWidth variant="outlined">
								<InputLabel>Accommodation</InputLabel>
								<Select
									multiple
									value={filters.accomodation}
									onChange={(e) => onFilterChange(e.target.name, e.target.value)}
									label="Accommodation"
									name="accomodation"
								>
									<MenuItem value={'ALL'}>All Types</MenuItem>
									{[
										ACCOMODATION_CATEGORY.DORMATORY,
										ACCOMODATION_CATEGORY.ROOM,
										ACCOMODATION_CATEGORY.PREMIUM,
									].map((acc) => (
										<MenuItem key={acc.id} value={acc.id}>{acc.name}</MenuItem>
									))}
								</Select>
							</FormControl>
						</Grid>
						<Grid item xs={12} sm={6} md={3}>
							<FormControl fullWidth variant="outlined">
								<InputLabel>Status</InputLabel>
								<Select
									multiple
									value={filters.status}
									onChange={(e) => onFilterChange(e.target.name, e.target.value)}
									label="Status"
									name="status"
								>
									<MenuItem value={'ALL'}>All Status</MenuItem>
									{getKeysInSameOrder(EVENT_BOOKING_STATUS)
										.filter((el) => String(el) !== '1')
										.map((statusKey) => (
											<MenuItem key={statusKey} value={statusKey}>
												{EVENT_BOOKING_STATUS[statusKey]}
											</MenuItem>
										))}
								</Select>
							</FormControl>
						</Grid>
					</Grid>
				</CardContent>
			</Card>

			{/* Data Grid */}
			<Card>
				<CardContent sx={{ p: 0 }}>
					<CustomDataGrid
						rows={transformData(data)}
						columns={headCells.map((col) => ({
							...col,
							sortable: true,
							disableClickEventBubbling: true,
							...(isMobileScreen()
								? rowWidthConfig[col.field]?.mobile ||
								rowWidthConfig[col.field]?.default
								: rowWidthConfig[col.field]?.default),
						}))}
						initialState={{
							pagination: {
								paginationModel: {
									pageSize: filters.pageSize,
								},
							},
						}}
						rowCount={rowCount}
						loading={loading}
						paginationModel={filters}
						onPaginationModelChange={(page) =>
							onPageSizeChange({
								pageSize: page.pageSize,
								page: page.pageSize != filters.pageSize ? 0 : page.page,
							})
						}
					/>
				</CardContent>
			</Card>
		</div>
	)
}

export default ReportScreen
